export class Company {
    Id: number;
    Name: string;
    Address: string;
    ContactName: string;
    ContactAddress: string;
    ContactPhone: string;
    CreatedAt: string;
    UpdatedAt: string;
  }
  